import { Component, HostListener, ElementRef, inject } from '@angular/core';
import { NotificationService } from '@shared/services/notification.service';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIcon } from '@angular/material/icon';
import { NgClass, DatePipe } from '@angular/common';

@Component({
    selector: 'app-notifications-panel',
    templateUrl: './notifications-panel.component.html',
    styleUrls: ['./notifications-panel.component.scss'],
    imports: [MatTooltip, MatIcon, NgClass, DatePipe]
})
export class NotificationsPanelComponent {
  readonly notificationService = inject(NotificationService);

  isOpen = false;
  tab: 'all' | 'unread' | 'read' = 'all';

  private readonly el = inject(ElementRef);

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.el.nativeElement.contains(event.target)) {
      this.isOpen = false;
    }
  }

  toggle(event: MouseEvent): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  get filtered() {
    const list = this.notificationService.notifications();
    if (this.tab === 'unread') return list.filter(n => !n.isRead);
    if (this.tab === 'read') return list.filter(n => n.isRead);
    return list;
  }

  markAllAsRead(): void {
    const unreadIds = this.notificationService.notifications()
      .filter(n => !n.isRead)
      .map(n => n.notificationId);

    if (unreadIds.length > 0) {
      this.notificationService.markAsRead(unreadIds);
    }
  }
}